import React, { useEffect, useRef, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, TextareaAutosize, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Radio, RadioGroup, FormControlLabel, FormLabel, FormHelperText, Autocomplete
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { QuotationMaster } from '../TitleList';
import styled, { inputImages, inputStyles, inputNumber, inputNumbers } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm, selectParty } from '../Selectors/Master/ItemSelectors';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import Dropdown from '../FieldsComponents/Dropdown';
import { errorStyles } from '../../Utils/table';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';
import { fetchMultipleQuotMemo, insertMultipleQuotationEntry } from '../../Store/PHPSlice/Sale/MultipleQuot';
import { selectMultiQuotMemo } from '../Selectors/Master/MasterSelectors';

const MultiQuotation = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        firm: '',
        party: '',
        quotId: '',
        mqtMemo: '',
        userId: userdata?.ID
    });
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [errors, setErrors] = useState({});
    const [quotationlist, setQuotationlist] = useState([]);
    const [quotArr, setQuotArr] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const dispatch = useDispatch();
    const firmdata = useSelector(selectFirm);
    const partydata = useSelector(selectParty);
    const mqtMemo = useSelector(selectMultiQuotMemo);
    // console.log(mqtMemo)

    useEffect(() => {
        dispatch(fetchCompanyData());
        dispatch(fetchPartyData());
        dispatch(fetchMultipleQuotMemo());
        fetchQuotationMulti();
    }, []);

    useEffect(() => {
        if (mqtMemo?.data) {
            const memo = mqtMemo?.data?.qt_memo;
            setFormData(prev => ({
                ...prev,
                mqtMemo: memo
            }));
        }
    }, [mqtMemo]);

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };


    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const handleAddQuotation = () => {
        if (formData.quotId !== '') {
            const quotdata = quotationlist?.find((item) => item.ID === formData.quotId);
            setQuotArr(prev => ([...prev, quotdata]));
            setFormData(prev => ({
                ...prev,
                quotId: ''
            }));
        } else {
            alert('select Quotation No')
        }
    };

    const handleRemoveQuotation = (idx) => {
        const filterQuotation = quotArr?.filter((_, index) => index !== idx);
        setQuotArr(filterQuotation);
    };

    const handleGetDataQuotation = () => {
        if (quotArr?.length > 0 && formData.firm.trim() !== '' && formData.party.trim() !== '') {
            fetchQuotSizeRateData(quotArr);
        } else {
            alert('Select Firm And Party');
        }
    };

    const dropdownFirm = [
        {
            label: 'Firm',
            id: 'firm',
            options: firmdata?.data || [],
            value: formData.firm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const dropdownparty = [
        {
            label: 'Party',
            id: 'party',
            options: partydata?.data || [],
            value: formData.party,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'party', value: newValue ? newValue.ID : '' } }, 'party'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const dropdownQuotation = [
        {
            label: 'Quotation No',
            id: 'quotId',
            options: quotationlist?.filter((quot) => !quotArr.some(item => item.ID === quot.ID)) || [],
            value: formData.quotId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'quotId', value: newValue ? newValue.ID : '' } }, 'quotId'),
            getOptionLabel: (option) => option.quot || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: handleAddQuotation,
            btnlabel: 'Add'
        }
    ];

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    const fetchQuotationMulti = async () => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getMultiQuotationlist`);
            // console.log(response?.data?.data);
            setQuotationlist(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };


    const fetchQuotSizeRateData = async (quotArr) => {
        try {
            const response = await axios.post(`${baseUrl}?apicall=getMultipleQuotSizerate_data`, { quotArr });
            // console.log(response?.data);
            if (response?.data?.data?.length > 0) {
                const forms = {
                    dt: formData.dt,
                    quotData: response?.data?.data,
                    firm: firmdata?.data?.find(item => item.ID === formData.firm)?.firmNm,
                    firmId: formData.firm,
                    party: partydata?.data?.find(item => item.ID === formData.party)?.partyNm
                };

                // Construct the URL with query parameters or use a placeholder route
                const url = `/QuotationViewTwo?form=${encodeURIComponent(JSON.stringify(forms))}`;

                // Open the URL in a new tab
                window.open(url, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
            }
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        const finaldata = {
            dt: formData.dt,
            firm: formData.firm,
            party: formData.party,
            userId: formData.userId,
            mqtMemo: formData.mqtMemo,
            quotArr: quotArr
        };
        // console.log(finalobj);
        dispatch(insertMultipleQuotationEntry(finaldata))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Sale Order Added");
                // window.location.reload();
                alert('Multiple Quotation');
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>
            <Titlebar data={QuotationMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Multiple Quotation</h2>
                <Grid container>
                    <Grid item>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Multi Quot Memo.', name: 'mqtMemo', type: 'readOnly' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {
                                    dropdownFirm?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {
                                    dropdownparty?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {
                                    dropdownQuotation?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                        />
                                    ))
                                }

                                {quotArr?.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table sx={{ width: '40%', textAlign: 'center' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }}>Sr.No</TableCell>
                                                        <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }}>Quotation</TableCell>
                                                        <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }}>Delete</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                {
                                                    quotArr?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}>{index + 1}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}>{item.quot}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}><DeleteIcon className='cursor-pointer' onClick={() => handleRemoveQuotation(index)} /></TableCell>
                                                        </TableRow>
                                                    ))
                                                }

                                            </Table>
                                        </TableContainer>

                                        <Grid item xs={12} md={2}>
                                            <Button variant="contained" color="primary" onClick={handleGetDataQuotation}>Print</Button>
                                        </Grid>
                                    </>
                                }
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default MultiQuotation;
